export default (nominal: number): string => `Rp. ${Number(nominal).toLocaleString('id-ID')}`
